import { useEffect, type MutableRefObject } from 'react';

export const useButtonKeyboardFocus = (
  buttonRef: MutableRefObject<HTMLButtonElement | undefined>,
  shouldFocus: boolean,
  onFocus: () => void,
) => {
  useEffect(() => {
    if (shouldFocus && buttonRef.current) {
      onFocus();
      buttonRef.current?.focus();
    }
  }, [buttonRef, shouldFocus, onFocus]);
};
